import { Participante } from './participante.model';
import { DemonstrativoDeResultado } from './demonstrativo-de-resultado.model';
import { UtilitarioService } from '@app/services/utilitario.service';

export class Receber {

  Id: number;
  Numero: string;
  Parcela: string;
  ParticipanteId: number;
  Participante: Participante;
  FormaDePagamentoCodigo: string;
  Emissao: string;
  Vencimento: string;
  DataRecebimento: Date;
  Valor: number;
  JurosAtraso: number;
  JurosFinanciamento: number;
  Desconto: number;
  TaxaCartao: number;
  UsuarioRecebimentoId: number;
  ValorRecebido: number;
  Historico: string;
  ParticipanteNome: string;
  BoletoNossoNumero: string;
  BoletoContaId: number;
  DemonstrativoDeResultadoId: number;
  DemonstrativoDeResultado: DemonstrativoDeResultado;
  ProcessoId: number;
  UnidadeId: number;
  NumeroCopias: number;
  CreditoCliente: boolean;
  DivisaoHonorariosId: number;
  TutelaProvisoriaId: number;

  constructor() {
    this.Id = 0;
    this.Participante = new Participante();
    this.DemonstrativoDeResultado = new DemonstrativoDeResultado();
  }

}

export class ReceberListaFiltros {
  ParticipanteId: number;
  PagasRecebidas: boolean;
  NaoPagasRecebidas: boolean;
  ProcessoId: number;
  DataInicial: string;
  DataFinal: string;
  //DataInicial: Date;
  //DataFinal: Date;
  Pagina: number;
  UnidadeId: number;
  TipoData: string;

  constructor(colocarData = true) {
    this.PagasRecebidas = false;
    this.NaoPagasRecebidas = true;
    this.ParticipanteId = 0;
    this.ProcessoId = 0;
    this.UnidadeId = 0;
    this.TipoData = 'Vencimento';
    this.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    this.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(7);

    // if (colocarData) {
    //   this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    //   this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(7);
    // } else {
    //   this.DataFinal = '';
    //   this.DataInicial = '';
    // }
  }
}

export class ReceberLista {
  Id: number;
  checked: boolean;
  Numero: string;
  Parcela: string;
  Cliente: string;
  // FormaDePagamentoCodigo: String;
  Vencimento: string;
  DataRecebimento: string;
  Valor: number;
  Desconto: number;
  ValorRecebido: number;
  Historico: string;
  // Selecionado: boolean;
  ExibirHistorico: boolean;
  // UnidadeId: number;
  ProcessoId: number;
  // ReferenciaId: number;
  DemonstrativoDeResultado: string;
  Quitado: boolean;

  constructor() {
    //  this.UnidadeId = 0;
  }
}
